module.exports = "/_next/static/images/cake-86d9f3d9bd40ce35848cdb051f25b88b.png";